/* Phidia theme: bag drawer, quick view, wishlist, product form, recently viewed. Uses Shopify's AJAX Cart API. */
(function () {
  'use strict';
  const T = window.theme || {};
  const R = T.routes || {};
  const root = (R.root || '/').replace(/\/$/, '');
  const overlay = document.getElementById('overlay');

  /* ---------- Helpers ---------- */
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  function money(cents) {
    const fmt = T.moneyFormat || '${{amount}}';
    const re = /\{\{\s*(\w+)\s*\}\}/;
    const m = fmt.match(re);
    const n = (d, ts, ds) => {
      const parts = (Math.round(cents) / 100).toFixed(d).split('.');
      const i = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return parts[1] ? i + ds + parts[1] : i;
    };
    if (!m) return n(2, ',', '.');
    const map = {
      amount: () => n(2, ',', '.'),
      amount_no_decimals: () => n(0, ',', '.'),
      amount_with_comma_separator: () => n(2, '.', ','),
      amount_no_decimals_with_comma_separator: () => n(0, '.', ','),
      amount_with_apostrophe_separator: () => n(2, "'", '.'),
      amount_with_space_separator: () => n(2, ' ', ',')
    };
    return fmt.replace(re, (map[m[1]] || map.amount)());
  }
  function img(url, width) {
    if (!url) return '';
    const u = url.startsWith('//') ? 'https:' + url : url;
    return u + (u.includes('?') ? '&' : '?') + 'width=' + width;
  }
  const PHI = '<svg class="ph" viewBox="-1 -1 89 109" aria-hidden="true"><use href="#phi"/></svg>';
  const HEART = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10Z"/></svg>';
  const X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  const BIN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/></svg>';
  const swatch = name => (T.swatches || {})[String(name).toLowerCase()] || String(name).toLowerCase().replace(/\s/g, '');
  const isColour = n => /^colou?r$/i.test(n);
  const isSize = n => /^size$/i.test(n);
  const productCache = {};
  async function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch(`${root}/products/${encodeURIComponent(handle)}.js`, {headers: {Accept: 'application/json'}})
        .then(r => { if (!r.ok) throw new Error('not found'); return r.json(); })
        .catch(e => { delete productCache[handle]; throw e; });
    }
    return productCache[handle];
  }

  let toastT;
  function toast(msg) {
    const t = document.getElementById('toast'); if (!t) return;
    t.hidden = true; void t.offsetWidth;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toastT); toastT = setTimeout(() => { t.hidden = true; }, 2600);
  }
  function setCount(id, n, bump) {
    const c = document.getElementById(id); if (!c) return;
    c.textContent = n; c.hidden = n === 0;
    if (bump) { c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump'); }
  }

  /* ---------- Overlay (modal + drawers) ---------- */
  let lastFocus = null;
  function openOverlay(html) {
    if (!overlay.innerHTML) lastFocus = document.activeElement;
    overlay.className = '';
    overlay.innerHTML = `<div class="scrim" data-close></div>${html}`;
    document.body.style.overflow = 'hidden';
    const f = overlay.querySelector('.close'); if (f) f.focus({preventScroll: true});
  }
  function closeOverlay() {
    if (!overlay.innerHTML) return;
    overlay.classList.add('closing');
    const done = () => {
      overlay.innerHTML = ''; overlay.className = ''; qv = null; document.body.style.overflow = '';
      if (lastFocus && document.contains(lastFocus)) lastFocus.focus({preventScroll: true});
    };
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) done(); else setTimeout(done, 240);
  }
  const drawer = kind => overlay.querySelector(`.drawer[data-kind="${kind}"]`);

  /* ---------- Bag drawer ---------- */
  async function cartFetch(url, body) {
    const r = await fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: body ? {'Content-Type': 'application/json', Accept: 'application/json'} : {Accept: 'application/json'},
      body: body ? JSON.stringify(body) : undefined
    });
    const j = await r.json();
    if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong');
    return j;
  }
  const getCart = () => cartFetch(`${R.cart}.js`);

  function cartHTML(cart) {
    const items = cart.items.length ? cart.items.map((l, i) => `<div class="bag-item" style="--i:${i}">
        <a class="thumb" href="${esc(l.url)}">${l.image ? `<img src="${esc(img(l.image, 240))}" alt="" loading="lazy">` : PHI}</a>
        <div><a class="t" href="${esc(l.url)}">${esc(l.product_title)}</a>${l.product_has_only_default_variant ? '' : `<div class="s">${esc(l.variant_title)}</div>`}
          <div class="line-actions"><div class="qty"><button type="button" data-qty="${esc(l.key)}" data-to="${l.quantity - 1}" aria-label="Remove one">−</button><span>${l.quantity}</span><button type="button" data-qty="${esc(l.key)}" data-to="${l.quantity + 1}" aria-label="Add one">+</button></div>
          <button type="button" class="rm" data-qty="${esc(l.key)}" data-to="0" data-removed="${esc(l.product_title)}" aria-label="Delete ${esc(l.product_title)} from bag">${BIN}Delete</button></div></div>
        <div class="p">${money(l.final_line_price)}</div></div>`).join('')
      : `<div class="bag-empty"><span>Your bag is empty.</span><a class="btn" href="${root}/collections/all">Start shopping</a></div>`;
    let ship = '';
    if (T.freeShipping > 0 && cart.items.length) {
      const left = T.freeShipping - cart.total_price;
      const pct = Math.min(100, Math.round(cart.total_price / T.freeShipping * 100));
      ship = `<div class="ship-bar">${left > 0 ? `You're ${money(left)} away from free shipping` : 'You’ve unlocked free shipping'}<div class="track"><i style="width:${pct}%"></i></div></div>`;
    }
    return `<div class="drawer-head"><h2>Your bag</h2><button class="close" type="button" data-close aria-label="Close bag">${X}</button></div>
      <div class="bag-items">${ship}${items}<div data-upsell></div></div>
      ${cart.items.length ? `<div class="bag-foot"><div class="row"><span>Subtotal</span><span>${money(cart.total_price)}</span></div>
        <a class="btn block" href="${root}/checkout">Checkout <span class="arrow" aria-hidden="true">→</span></a>
        <small>Shipping and discount codes are added at checkout.${T.returnsNote ? ' ' + esc(T.returnsNote) : ''}</small></div>` : ''}`;
  }
  async function loadUpsell(cart) {
    const slot = overlay.querySelector('[data-upsell]'); if (!slot || !cart.items.length) return;
    try {
      const inCart = cart.items.map(i => i.product_id);
      const j = await cartFetch(`${R.recommendations}.json?product_id=${cart.items[0].product_id}&limit=6`);
      const p = (j.products || []).find(x => !inCart.includes(x.id) && x.available);
      if (!p) return;
      slot.innerHTML = `<div class="upsell"><span class="eyebrow">Complete the look</span>
        <button class="up" type="button" data-quick="${esc(p.handle)}"><span class="thumb">${p.featured_image ? `<img src="${esc(img(p.featured_image, 160))}" alt="" loading="lazy">` : PHI}</span><span><span class="t">${esc(p.title)}</span><br><span class="s">${money(p.price)}</span></span><span class="go">View</span></button></div>`;
    } catch (e) { /* recommendations are optional */ }
  }
  async function renderCart(isStatic) {
    const d = drawer('bag'); if (!d) return;
    try {
      const cart = await getCart();
      if (!drawer('bag')) return;
      d.classList.toggle('static', !!isStatic);
      d.innerHTML = cartHTML(cart);
      setCount('bagCount', cart.item_count);
      loadUpsell(cart);
    } catch (e) { d.innerHTML = `<div class="drawer-head"><h2>Your bag</h2><button class="close" type="button" data-close aria-label="Close bag">${X}</button></div><p class="loading">${esc(e.message)}</p>`; }
  }
  function openCart() {
    if (location.pathname === R.cart) { location.reload(); return; }
    openOverlay(`<aside class="drawer" data-kind="bag" role="dialog" aria-modal="true" aria-label="Your bag"><div class="drawer-head"><h2>Your bag</h2><button class="close" type="button" data-close aria-label="Close bag">${X}</button></div><div class="loading"><span class="spinner"></span></div></aside>`);
    renderCart(false);
  }
  async function changeLine(btn) {
    const d = drawer('bag'); if (d) d.classList.add('busy');
    try {
      const cart = await cartFetch(`${R.cartChange}.js`, {id: btn.dataset.qty, quantity: Math.max(0, +btn.dataset.to)});
      setCount('bagCount', cart.item_count, true);
      if (btn.dataset.removed) toast(`Removed ${btn.dataset.removed}`);
      const dd = drawer('bag');
      if (dd) { dd.classList.remove('busy'); dd.classList.add('static'); dd.innerHTML = cartHTML(cart); loadUpsell(cart); }
    } catch (e) { toast(e.message); if (d) d.classList.remove('busy'); }
  }
  async function addToCart(variantId, qty, label) {
    const res = await cartFetch(`${R.cartAdd}.js`, {items: [{id: variantId, quantity: qty || 1}]});
    const cart = await getCart();
    setCount('bagCount', cart.item_count, true);
    toast(`Added ${label || (res.items && res.items[0] && res.items[0].title) || 'item'} to your bag`);
    return cart;
  }

  /* ---------- Wishlist ---------- */
  let favs = store.get('phidia-favs', []).filter(h => typeof h === 'string');
  function syncFavButtons() {
    document.querySelectorAll('[data-fav]').forEach(b => b.setAttribute('aria-pressed', String(favs.includes(b.dataset.fav))));
    setCount('favCount', favs.length);
  }
  async function favHTML() {
    if (!favs.length) return `<div class="bag-empty"><span>Nothing saved yet. Tap the heart on any product to keep it here.</span><a class="btn" href="${root}/collections/all">Start shopping</a></div>`;
    const list = await Promise.all(favs.map(h => getProduct(h).catch(() => null)));
    const gone = favs.filter((h, i) => !list[i]);
    if (gone.length) { favs = favs.filter(h => !gone.includes(h)); store.set('phidia-favs', favs); syncFavButtons(); }
    return list.filter(Boolean).map((p, i) => `<div class="bag-item fav-item" style="--i:${i}">
      <a class="thumb" href="${esc(p.url || `${root}/products/${p.handle}`)}">${p.featured_image ? `<img src="${esc(img(p.featured_image, 240))}" alt="" loading="lazy">` : PHI}</a>
      <div><div class="t">${esc(p.title)}</div><div class="s">${p.available ? '' : 'Sold out'}</div>
        <div class="acts"><button type="button" data-quick="${esc(p.handle)}">Choose size</button><button type="button" data-fav-remove="${esc(p.handle)}" aria-label="Remove ${esc(p.title)} from wishlist">Remove</button></div></div>
      <div class="p">${money(p.price)}</div></div>`).join('');
  }
  async function renderFav(isStatic) {
    const d = drawer('fav'); if (!d) return;
    const body = await favHTML();
    if (!drawer('fav')) return;
    d.classList.toggle('static', !!isStatic);
    d.innerHTML = `<div class="drawer-head"><h2>Wishlist</h2><button class="close" type="button" data-close aria-label="Close wishlist">${X}</button></div><div class="bag-items">${body}</div>`;
  }
  function openFav() {
    openOverlay(`<aside class="drawer" data-kind="fav" role="dialog" aria-modal="true" aria-label="Wishlist"><div class="drawer-head"><h2>Wishlist</h2><button class="close" type="button" data-close aria-label="Close wishlist">${X}</button></div><div class="loading"><span class="spinner"></span></div></aside>`);
    renderFav(false);
  }
  function toggleFav(handle) {
    const i = favs.indexOf(handle);
    if (i > -1) favs.splice(i, 1); else favs.unshift(handle);
    store.set('phidia-favs', favs);
    syncFavButtons();
    setCount('favCount', favs.length, true);
    toast(i > -1 ? 'Removed from your wishlist' : 'Saved to your wishlist');
    if (drawer('fav')) renderFav(true);
  }

  /* ---------- Quick view ---------- */
  let qv = null;
  function variantFor(p, sel) {
    if (sel.some(v => v == null)) return null;
    return p.variants.find(v => v.options.every((o, i) => o === sel[i])) || null;
  }
  function qvImages(p) {
    return (p.media || []).filter(m => m.media_type === 'image').map(m => m.src).concat(p.media && p.media.length ? [] : (p.images || []));
  }
  function qvHTML() {
    const p = qv.p, v = variantFor(p, qv.sel) || p.variants.find(x => x.available) || p.variants[0];
    const imgs = qvImages(p);
    const mainSrc = imgs[qv.img] || (v.featured_image && v.featured_image.src) || imgs[0];
    const labels = imgs.length === 2 ? ['Front', 'Back'] : imgs.map((_, i) => String(i + 1));
    const opts = p.options.map((o, oi) => {
      const name = o.name || o, values = o.values || [];
      if (name === 'Title' && values.length === 1 && values[0] === 'Default Title') return '';
      const colour = isColour(name);
      return `<div><div class="opt-label">${esc(name)} <span>${esc(qv.sel[oi] || (isSize(name) ? 'Select a size' : ''))}</span></div>
        <div class="values${colour ? ' colour' : isSize(name) ? ' size' : ''}">${values.map(val => {
          const avail = p.variants.some(x => x.available && x.options[oi] === val && x.options.every((o2, j) => j === oi || qv.sel[j] == null || o2 === qv.sel[j]));
          return `<button type="button" class="v${avail ? '' : ' na'}" data-qv-opt="${oi}" data-val="${esc(val)}" aria-pressed="${qv.sel[oi] === val}"${colour ? ` style="--sw:${esc(swatch(val))}" title="${esc(val)}" aria-label="${esc(val)}"` : ''}>${colour ? '' : esc(val)}</button>`;
        }).join('')}</div></div>`;
    }).join('');
    const chosen = variantFor(p, qv.sel);
    const btnLabel = chosen && !chosen.available ? 'Sold out' : 'Add to bag';
    const price = (chosen || v).price;
    return `<div class="gallery"><button class="close" type="button" data-close aria-label="Close">${X}</button>
        <div class="stage">${mainSrc ? `<img src="${esc(img(mainSrc, 900))}" alt="${esc(p.title)}">` : PHI}</div>
        ${imgs.length > 1 ? `<div class="view-toggle">${imgs.slice(0, 4).map((_, i) => `<button type="button" data-qv-img="${i}" aria-pressed="${i === qv.img}">${labels[i]}</button>`).join('')}</div>` : ''}
      </div>
      <div class="info">
        <h2>${esc(p.title)}</h2>
        <span class="price">${money(price)}</span>
        ${T.afterpay ? `<span class="ap">or 4 interest-free payments of <b>${money(Math.floor(price / 4))}</b> with Afterpay</span>` : ''}
        ${opts}
        <div data-qv-err></div>
        <div class="add-row"><button class="btn" type="button" data-qv-add${chosen && !chosen.available ? ' disabled' : ''}>${btnLabel}</button><button class="btn ghost fav-btn" type="button" data-fav="${esc(p.handle)}" aria-pressed="${favs.includes(p.handle)}" aria-label="Save to wishlist">${HEART}</button></div>
        <a class="more" href="${esc(p.url || `${root}/products/${p.handle}`)}">View full details</a>
      </div>`;
  }
  function renderQV(isStatic) {
    const m = overlay.querySelector('.modal');
    if (m) { m.classList.toggle('static', !!isStatic); m.innerHTML = qvHTML(); return; }
    openOverlay(`<div class="modal" role="dialog" aria-modal="true" aria-label="${esc(qv.p.title)}">${qvHTML()}</div>`);
  }
  async function openQuick(handle) {
    try {
      const p = await getProduct(handle);
      const first = p.variants.find(v => v.available) || p.variants[0];
      const sel = p.options.map((o, i) => (isSize(o.name || o) && p.variants.length > 1) ? null : first.options[i]);
      qv = {p, sel, img: 0};
      renderQV(false);
      recordRecent(handle);
    } catch (e) { location.href = `${root}/products/${handle}`; }
  }
  async function qvAdd(btn) {
    const v = variantFor(qv.p, qv.sel);
    const err = overlay.querySelector('[data-qv-err]');
    if (!v) {
      const missing = qv.p.options[qv.sel.findIndex(s => s == null)];
      err.innerHTML = `<p class="err">Choose a ${esc(String((missing && missing.name) || 'option').toLowerCase())} to add this to your bag.</p>`;
      return;
    }
    btn.disabled = true; btn.innerHTML = '<span class="spinner"></span>';
    try {
      const label = `${qv.p.title}${v.title && v.title !== 'Default Title' ? ' · ' + v.title : ''}`;
      await addToCart(v.id, 1, label);
      closeOverlay();
    } catch (e) { err.innerHTML = `<p class="err">${esc(e.message)}</p>`; btn.disabled = false; btn.textContent = 'Add to bag'; }
  }

  /* ---------- Product page form ---------- */
  function initProductForm(form) {
    const jsonEl = form.querySelector('[data-product-json]'); if (!jsonEl) return;
    const p = JSON.parse(jsonEl.textContent);
    const idInput = form.querySelector('[data-variant-id]');
    const btn = form.querySelector('[data-add]');
    const err = form.querySelector('[data-form-error]');
    const groups = [...form.querySelectorAll('[data-option-group]')];
    const priceEl = document.querySelector('[data-price]');
    const apEl = document.querySelector('[data-afterpay] b');
    const selected = () => groups.map(g => { const c = g.querySelector('input:checked'); return c ? c.value : null; });

    function update() {
      const sel = selected();
      groups.forEach((g, i) => {
        const lab = g.querySelector('[data-option-label]'); if (lab && sel[i]) lab.textContent = sel[i];
        g.querySelectorAll('input[data-option]').forEach(inp => {
          const ok = p.variants.some(v => v.available && v.options[i] === inp.value && v.options.every((o, j) => j === i || sel[j] == null || o === sel[j]));
          inp.nextElementSibling.classList.toggle('na', !ok);
        });
      });
      if (sel.some(s => s == null)) return;
      const v = p.variants.find(x => x.options.every((o, i) => o === sel[i]));
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      btn.disabled = !v.available; btn.textContent = v.available ? 'Add to bag' : 'Sold out';
      if (priceEl) priceEl.innerHTML = money(v.price) + (v.compare_at_price > v.price ? `<s>${money(v.compare_at_price)}</s>` : '');
      if (apEl) apEl.textContent = money(Math.floor(v.price / 4));
      if (v.featured_media) {
        const slide = document.querySelector(`[data-gallery] [data-media-id="${v.featured_media.id}"]`);
        const gal = document.querySelector('[data-gallery]');
        if (slide && gal && gal.firstElementChild !== slide) { gal.prepend(slide); }
      }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
    }
    form.addEventListener('change', e => { if (e.target.matches('[data-option]')) { err.innerHTML = ''; update(); } });
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const sel = selected();
      const missing = groups.findIndex((g, i) => sel[i] == null);
      if (missing > -1) {
        err.innerHTML = `<p class="err">Choose a ${esc(groups[missing].dataset.optionName.toLowerCase())} to add this to your bag.</p>`;
        groups[missing].scrollIntoView({block: 'center', behavior: 'smooth'});
        return;
      }
      const label = btn.textContent;
      btn.disabled = true; btn.innerHTML = '<span class="spinner"></span>';
      try {
        const v = p.variants.find(x => String(x.id) === String(idInput.value));
        await addToCart(+idInput.value, 1, `${p.title}${v && v.title !== 'Default Title' ? ' · ' + v.title : ''}`);
        openCart();
      } catch (ex) { err.innerHTML = `<p class="err">${esc(ex.message)}</p>`; }
      btn.disabled = false; btn.textContent = label;
    });
    update();
  }

  /* ---------- Product recommendations ("Pairs well with") ---------- */
  async function loadPairs(el) {
    try {
      const r = await fetch(el.dataset.url); const html = await r.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('.pairs-inner');
      if (inner && inner.querySelector('.pair')) { el.innerHTML = inner.innerHTML; el.hidden = false; }
    } catch (e) {}
  }

  /* ---------- Recently viewed ---------- */
  function recordRecent(handle) {
    const list = store.get('phidia-recent', []).filter(h => h !== handle);
    store.set('phidia-recent', [handle, ...list].slice(0, 8));
  }
  async function renderRecent(wrapEl) {
    const current = (document.querySelector('[data-recent-record]') || {}).dataset;
    const handles = store.get('phidia-recent', []).filter(h => !current || h !== current.recentRecord).slice(0, 4);
    if (!handles.length) return;
    const list = (await Promise.all(handles.map(h => getProduct(h).catch(() => null)))).filter(Boolean);
    if (!list.length) return;
    wrapEl.querySelector('[data-recent-grid]').innerHTML = list.map((p, i) => `<div class="cwrap r" style="--i:${i}">
      <div class="img"><a class="img-link" href="${esc(p.url)}" tabindex="-1" aria-hidden="true"><div class="face front">${p.featured_image ? `<img src="${esc(img(p.featured_image, 600))}" alt="" loading="lazy">` : PHI}</div></a>
        <button class="fav" type="button" data-fav="${esc(p.handle)}" aria-pressed="${favs.includes(p.handle)}" aria-label="Save ${esc(p.title)} to wishlist">${HEART}</button>
        <button class="quick" type="button" data-quick="${esc(p.handle)}">Quick view</button></div>
      <a class="meta" href="${esc(p.url)}"><span class="name">${esc(p.title)}</span><span class="price">${p.price_varies ? 'From ' : ''}${money(p.price)}</span></a></div>`).join('');
    wrapEl.hidden = false;
  }

  /* ---------- Global events ---------- */
  document.addEventListener('click', e => {
    const t = e.target.closest('[data-close],[data-quick],[data-fav],[data-fav-remove],[data-qty],[data-qv-opt],[data-qv-img],[data-qv-add],#bagBtn,#favBtn,#menuBtn');
    if (!t) return;
    if (t.matches('[data-close]')) { closeOverlay(); }
    else if (t.id === 'bagBtn') { e.preventDefault(); openCart(); }
    else if (t.id === 'favBtn') { openFav(); }
    else if (t.id === 'menuBtn') {
      const nav = document.getElementById('mobileNav'); nav.hidden = !nav.hidden; t.setAttribute('aria-expanded', String(!nav.hidden));
    }
    else if (t.matches('[data-quick]')) { e.preventDefault(); openQuick(t.dataset.quick); }
    else if (t.matches('[data-fav]')) { toggleFav(t.dataset.fav); }
    else if (t.matches('[data-fav-remove]')) { toggleFav(t.dataset.favRemove); }
    else if (t.matches('[data-qty]')) { changeLine(t); }
    else if (t.matches('[data-qv-opt]')) {
      const i = +t.dataset.qvOpt; qv.sel[i] = t.dataset.val;
      const v = variantFor(qv.p, qv.sel);
      if (v && v.featured_image) { const idx = qvImages(qv.p).indexOf(v.featured_image.src); if (idx > -1) qv.img = idx; }
      renderQV(true);
    }
    else if (t.matches('[data-qv-img]')) { qv.img = +t.dataset.qvImg; renderQV(true); }
    else if (t.matches('[data-qv-add]')) { qvAdd(t); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && overlay.innerHTML) closeOverlay(); });
  document.addEventListener('change', e => {
    if (e.target.matches('[data-sort]')) {
      const url = new URL(location.href); url.searchParams.set('sort_by', e.target.value); url.searchParams.delete('page'); location.href = url;
    }
  });

  /* ---------- Init ---------- */
  const header = document.getElementById('siteHeader');
  if (header) addEventListener('scroll', () => header.classList.toggle('scrolled', scrollY > 8), {passive: true});

  const msgEl = document.querySelector('[data-messages]');
  if (msgEl) {
    const msgs = msgEl.dataset.messages.split('||').filter(Boolean);
    if (msgs.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let mi = 0;
      setInterval(() => {
        msgEl.classList.add('out');
        setTimeout(() => { mi = (mi + 1) % msgs.length; msgEl.textContent = msgs[mi]; msgEl.classList.remove('out'); }, 350);
      }, 4200);
    }
  }

  document.querySelectorAll('form[data-product-form]').forEach(initProductForm);
  document.querySelectorAll('[data-recommendations]').forEach(loadPairs);
  const rec = document.querySelector('[data-recent-record]');
  if (rec) recordRecent(rec.dataset.recentRecord);
  document.querySelectorAll('[data-recent]').forEach(renderRecent);
  syncFavButtons();
})();
